import React, { useState, useContext } from 'react';
import * as FaIcons from 'react-icons/fa';
import * as AiIcons from 'react-icons/ai';
import { Link, useNavigate } from 'react-router-dom';
import { EventSidebarData } from '../data/eventSidebarData';
import '../styles/NavigationBar.scss';
import { IconContext } from 'react-icons';
import { UserContext } from '../context/UserContext';

const EventNavbar = () => {
    const {logout} = useContext(UserContext);
  const [sidebar, setSidebar] = useState(false);
  const navigate = useNavigate()

  const showSidebar = () => setSidebar(!sidebar);

  const doLogout = () => {
    logout();
    navigate('/');
  }

  return (
    <>
      <IconContext.Provider value={{ color: '#fff' }}>
        <div className='navbar'>
          <Link to='#' className='menu-bars'>
            <FaIcons.FaBars onClick={showSidebar} />
          </Link>
          <button onClick={doLogout} className="logout">Kijelentkezés</button>
        </div>
        <nav className={sidebar ? 'nav-menu active' : 'nav-menu'}>
          <ul className='nav-menu-items' onClick={showSidebar}>
            <li className='navbar-toggle'>
              <Link to='#' className='menu-bars'>
                <AiIcons.AiOutlineClose />
              </Link>
            </li>
            {EventSidebarData.map((item, index) => {
              return (
                <li key={index} className={item.cName}>
                  <Link to={item.path}>
                    {item.icon}
                    <span>{item.title}</span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>
      </IconContext.Provider>
    </>
  );
}

export default EventNavbar;